/**
 * Keyboard-shortcut helpers shared across the app.
 *
 * Canonical rules live in `docs/ui-ux-patterns.md §10`:
 *  - single-key shortcuts must suppress while the user is typing in an
 *    `<input>`, `<textarea>`, `[contenteditable]`, or inside a Radix
 *    combobox / listbox input that catches keystrokes.
 *  - combo shortcuts (Cmd/Ctrl+K, Cmd/Ctrl+Enter) still fire inside
 *    text fields — they mean "do this app-level thing regardless".
 */

const EDITABLE_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

/** Returns true when a keydown event originated inside editable text. */
export function isTypingIn(el: EventTarget | null): boolean {
  if (!(el instanceof HTMLElement)) return false
  if (EDITABLE_TAGS.has(el.tagName)) return true
  if (el.isContentEditable) return true
  // Radix combobox / listbox inputs carry this role on their trigger.
  const role = el.getAttribute('role')
  if (role === 'combobox' || role === 'searchbox') return true
  return false
}
